import React from "react";
import Container from "../components/common/Container";
import SectionHeader from "../components/common/SectionHeader";
import ServiceCard from "../components/services/ServiceCard";
import {
  Code2,
  Smartphone,
  Palette,
  Brain,
  Cloud,
  ShieldCheck,
} from "lucide-react";

const Services = () => {
  return (
    <>
      {/* Page Header */}
      <section className="bg-slate-50 py-24">
        <Container>
          <center>
          <SectionHeader
            eyebrow="Our Services"
            title="Comprehensive software solutions for modern businesses"
            subtitle="We help companies design, build, and scale software products using modern technologies and proven engineering practices."
          />
          </center>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <Container>
          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
            <ServiceCard
              icon={Code2}
              title="Web Development"
              description="Scalable, secure, and high-performance web applications tailored to your business needs."
              features={[
                "React, Next.js & modern frameworks",
                "API design & backend integration",
                "Performance optimization",
                "Enterprise-grade security",
              ]}
            />

            <ServiceCard
              icon={Smartphone}
              title="Mobile Applications"
              description="High-quality mobile experiences for iOS and Android platforms."
              features={[
                "iOS & Android development",
                "React Native & Flutter",
                "App Store deployment",
                "Ongoing maintenance & updates",
              ]}
            />

            <ServiceCard
              icon={Palette}
              title="UI/UX Design"
              description="Beautiful, intuitive interfaces designed to convert users into customers."
              features={[
                "User research & wireframing",
                "Design systems",
                "Prototyping & usability testing",
                "Accessibility-first design",
              ]}
            />

            <ServiceCard
              icon={Brain}
              title="AI & Automation"
              description="Intelligent solutions that automate processes and unlock data-driven insights."
              features={[
                "AI-powered workflows",
                "Chatbots & virtual assistants",
                "Data analysis & predictions",
                "Custom ML solutions",
              ]}
            />

            <ServiceCard
              icon={Cloud}
              title="Cloud & DevOps"
              description="Reliable, scalable infrastructure that grows with your business."
              features={[
                "AWS, GCP & Azure",
                "CI/CD pipelines",
                "Infrastructure as code",
                "Monitoring & scaling",
              ]}
            />

            <ServiceCard
              icon={ShieldCheck}
              title="Security & Compliance"
              description="Protect your applications and data with enterprise-grade security practices."
              features={[
                "Secure architecture",
                "Authentication & authorization",
                "Compliance best practices",
                "Regular audits & testing",
              ]}
            />
          </div>
        </Container>
      </section>
    </>
  );
};

export default Services;
